// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__vFBFm","loadingOverlay":"Loader_loadingOverlay__F1h8N","loader":"Loader_loader__bCvQw","rotateInfinity":"Loader_rotateInfinity__Du3f1"};